import { State } from 'shared/types/redux'
import { ResourceMetaData, MetaData } from 'client/shared/types/resource'

import { getMetaId } from '../helpers/meta-helpers'

export const getMetaData = (
  state: State,
  resourceData: ResourceMetaData,
): MetaData => {
  const metaId = getMetaId(resourceData)

  return state.meta.data[metaId]
}
